export default __webpack_public_path__ + "static/media/curve.b28135c7.svg";